import React from 'react';
import { Link, useResolvedPath } from 'react-router-dom';
import CustomButton from 'Components/common/CustomButton/CustomButton';
import Colors from 'constants/Colors';

const MenuButton = ({ path, text, IconComponent }) => {
  const resolved = useResolvedPath('.'); // Resuelve la ruta base actual

  return (
    <Link to={`${resolved.pathname}${path}`}>
      <CustomButton
        background={Colors.white}
        color={Colors.darkText}
        text={text}
        fontSize={12}
        leftComponent={<IconComponent style={{ fill: 'black' }} />}
      />
    </Link>
  );
};

export default MenuButton;
